export default __webpack_public_path__ + "067740f15369d2584da2f3fa6cb6ab6b.png";